import { type Theme } from "@mui/material";
import { Text, View } from "@react-pdf/renderer";
import { resolveAvailabilityStatus, resolveAvailabilityStatusColor } from "@src/pages/wishlist/components/pdf/components/tableRow/TableRow.utils";
import { trimSpaces } from "@src/pages/wishlist/components/pdf/WishlistPdf.utils";
import { type SPFAvailabilityStatus } from "@src/utils/events";
import { type FunctionComponent } from "react";
import { type IntlShape } from "react-intl";

import { styles } from "./TableRow.styles";

interface TableRowProps {
    entry: WishListPdfEntry;
    hasArticleInfos: boolean;
    intl: IntlShape;
    theme: Theme;
}

export interface WishListPdfEntry {
    article: {
        articleNumber: string;
        name: string;
    };
    info: {
        availability: SPFAvailabilityStatus;
        price: string;
        quantity: number;
    };
    model: {
        brand?: string;
        description: string;
        details: string;
    };
}

const TableRow: FunctionComponent<TableRowProps> = ({ entry, hasArticleInfos, intl, theme }) => {
    const availabilityStatus = entry.info.availability;

    return (
        <View style={styles.root}>
            <View style={styles.articleColumnContainer}>
                <Text style={styles.articleText}>{trimSpaces(entry.article.name)}</Text>
            </View>

            <View style={styles.articleNrColumnContainer}>
                <Text style={styles.articleNrText}>{entry.article.articleNumber}</Text>
            </View>

            <View style={styles.modelColumnContainer}>
                <Text style={styles.modelText}>{trimSpaces(entry.model.description)}</Text>

                <Text style={styles.modelText}>{trimSpaces(entry.model.details)}</Text>
            </View>

            {hasArticleInfos && (
                <>
                    <View style={styles.availabilityColumnContainer}>
                        <View style={[styles.availabilityIcon, { backgroundColor: resolveAvailabilityStatusColor(availabilityStatus, theme) }]} />

                        <Text style={styles.availabilityText}>{resolveAvailabilityStatus(availabilityStatus, intl)}</Text>
                    </View>

                    <View style={styles.priceColumnContainer}>
                        <Text style={styles.priceText}>{entry.info.price}</Text>
                    </View>

                    <View style={styles.quantityColumnContainer}>
                        <Text style={styles.quantityText}>{entry.info.quantity}</Text>
                    </View>
                </>
            )}
        </View>
    );
};

export { TableRow };
